import type { IRequest } from '../../common/interfaces/IRequest';
import { ServiceCode } from '../../common/enums/ServiceCode';

export const somnologyServiceCodes = [
    ServiceCode.OSASV,
    ServiceCode.OSASC1,
    ServiceCode.OSASO,
    ServiceCode.OSASVO,
    ServiceCode.OSASC2,
    ServiceCode.OSASQ,
];

export function getLastSomnologyRequest(requests?: IRequest[], excludeOsasq?: boolean) {
    if (!requests) {
        return null;
    }

    const somnologyRequests = requests.filter(
        (request) =>
            somnologyServiceCodes.includes(request.service.code) &&
            (!excludeOsasq || request.service.code !== ServiceCode.OSASQ)
    );

    if (somnologyRequests.length === 0) {
        return null;
    }

    return somnologyRequests[0];
}
